import { useEffect, useState } from 'react'
import { Route, Routes } from 'react-router-dom'
import styled from 'styled-components'
import Container from 'src/components/Container'
import { useCameraEmbedsGetActiveQuery } from 'shared/schema'

const REFRESH_INTERVAL_MS = 30000

const JobSiteFrame = styled.div`
	position: relative;
	width: 100%;
	aspect-ratio: 4 / 3;
	overflow: hidden;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}
`

const Caption = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	padding: 10px 20px;
	background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), transparent);
	color: #fff;
	font-weight: bold;
	font-size: 18px;
`

function JobSiteGallery() {
	const [ts, setTs] = useState(() => Date.now())
	const { data } = useCameraEmbedsGetActiveQuery()

	useEffect(() => {
		const id = setInterval(() => setTs(Date.now()), REFRESH_INTERVAL_MS)
		return () => clearInterval(id)
	}, [])

	const camera = data?.cameraEmbeds[0]
	if (!camera) return null

	return (
		<JobSiteFrame>
			<img src={`${camera.stillUrl}?ts=${ts}`} alt={camera.title} />
			<Caption>{camera.title}</Caption>
		</JobSiteFrame>
	)
}

function JobsiteVideosRoute() {
	return (
		<Container>
			<Routes>
				<Route path="/" element={<JobSiteGallery />} />
			</Routes>
		</Container>
	)
}

export default JobsiteVideosRoute
